/**
 * The signed-in person's own workspace invitations (the in-app invitation
 * modal, Figma MVP-DESIGNES 10216:3390 / 10219:22067, and the Pending rows of
 * the avatar menu, 10219:22909).  Backend:
 * `backend/app/routes/workspaces_route.py`, "Invitee inbox" section.
 *
 * Every call resolves `{ ok, data | error, status }` like `workspacesApi`.
 * None of them changes the active workspace: accepting from the modal adds
 * the workspace to the switcher and leaves the session where it is (the
 * email link, `JoinWorkspacePage`, is the flow that switches).
 */
import { sendJson } from './workspacesApi';

const invitationsPath = (suffix) => `workspaces/invitations${suffix}`;
const invitationPath = (invitationId, suffix) => invitationsPath(`/${encodeURIComponent(invitationId)}${suffix}`);

/**
 * `GET /workspaces/invitations/mine` -> `{ invitations: [{ id, workspace_id,
 * workspace_name, workspace_logo, role, inviter_email, inviter_name,
 * expires_at, dismissed }] }`, oldest first.  `dismissed` rows were closed
 * without a decision and must not re-open the modal on their own.
 */
export const fetchMyInvitations = () => sendJson('GET', invitationsPath('/mine'));

/** `POST /workspaces/invitations/{id}/accept` -> `{ workspace_id, workspace_name, role }`. */
export const acceptInvitation = (invitationId) => sendJson('POST', invitationPath(invitationId, '/accept'));

/** `POST /workspaces/invitations/{id}/decline` -> `{ success }`. */
export const declineInvitation = (invitationId) => sendJson('POST', invitationPath(invitationId, '/decline'));

/** `POST /workspaces/invitations/dismiss` -> `{ dismissed }` (how many were stamped). */
export const dismissInvitations = (invitationIds) =>
    sendJson('POST', invitationsPath('/dismiss'), { invitation_ids: invitationIds });
